import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { MessageService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { RadioButtonModule } from 'primeng/radiobutton';
import QRCode from 'qrcode';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { UploadModule } from '../../modal/upload/upload.module';
@Component({
  selector: 'app-trans-header-steper',
  imports: [
    CommonModule,
    DropdownModule,
    MultiSelectModule,
    FormsModule,
    DialogModule,
    ToastModule,
    RadioButtonModule,
    UploadModule  
  ],
  templateUrl: './trans-header-steper.component.html',
  providers: [MessageService, ToastModule],
  standalone: true
})
export class TransHeaderSteperComponent implements OnInit {

  // ====== Inputs ======
  @Input() filteredSteps: any;
  @Input() currentIndex: number;
  @Input() startIndex: number = 0;
  @Input() windowSize: number = 5;
  @Input() step_details: any;

  // ====== Outputs ======
  @Output() currentStepChange: EventEmitter<any> = new EventEmitter<any>();

  // ====== Basic Variables ======
  proposalId: any;
  currentStepId: any;
  activeSeq: number = 1;
  private stepChange$ = new Subject<number>();
  routeConfigExpanded: boolean = false;

  // ====== Session Storage Info ======
  currentUser: any = sessionStorage.getItem('user_id');
  currentUserRoleId: number = Number(sessionStorage.getItem('user_role_id'));
  currentUnit: number = +sessionStorage.getItem('unit_id');

  // ====== Lists and Data ======
  commandList: any[] = [];
  userList: any[] = [];
  unitList: any[] = [];
  workflowData: any = [];
  timelineDataList: any = [];
  groupedCommentTurns: any[] = [];
  editorData: any = null;

  // ====== State variables ======
  isLoading: boolean = false;
  showModal: boolean = false;
  displayDialog: boolean = false;

  // ====== Access control and selections ======
  accessObje = { edit: true, view: true, comment: true };
  shareType: string | null = null;
  permissionType: string | null = null;
  isFinalApproval: boolean = false;

  selectedUser: any = null;
  selectedUsers: any[] = [];
  selectedUnit: any = null;
  selectedUnits: any[] = [];
  selectedCommand: any = null;
  selectedUnitflow: any = null;

  // ====== Comments & Signature ======
  internalComment: string = '';
  externalComment: string = '';
  signatureData: any = null;

  private destroy$ = new Subject<void>();
  showShortCloseButton1: boolean = false;

  // ====== Constructor ======
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private messageService: MessageService
  ) {}

  // ====== Lifecycle ======
  ngOnInit(): void {
     this.route.queryParams.subscribe(params => {
       this.showShortCloseButton1 = params['short_close'] === 'true' || params['short_close'] === 'approved';
     });
    this.stepChange$
      .pipe(
        switchMap((stepId: number) => this.fetchPermDetails$(stepId)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  
    this.setChangeProposal();
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  setChangeProposal(id?: number): void {
    if (id != null) {
      this.proposalId = this.proposalId || Number(this.route.snapshot.queryParamMap.get('id'));
      this.currentStepId = id;
      this.stepChange$.next(this.currentStepId);
      return;
    }
  
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: any) => {
        this.proposalId = Number(params['id']);
        this.currentStepId = Number(params['step']);
  
        if (this.currentStepId) {
          this.stepChange$.next(this.currentStepId);
        } else if (this.filteredSteps?.length) {
          const firstStep = this.filteredSteps.find((s: any) => !s.skipped);
          if (firstStep) {
            this.currentStepId = firstStep.id;
            this.stepChange$.next(this.currentStepId);
          }
        }
      });
  }
  
  apiResponseSteps: any[] = [];
  
  getpermDetails(stepId: number): void {
    if (stepId == null) return;
    this.stepChange$.next(stepId);
  }

  private fetchPermDetails$(stepId: number): Observable<void> {
    const user_role_id = sessionStorage.getItem('user_role_id');
    return this.api
      .getAPI(`/transaction/copy/proposals/${this.proposalId}/steps/?role_id=${user_role_id}`)
      .pipe(
        tap((res: any) => {
          this.apiResponseSteps = Array.isArray(res) ? res : [];
          this.filteredSteps = this.apiResponseSteps.filter((item: any) => !item.skipped);

          if (!this.filteredSteps.length) {
            this.step_details = null;
            this.currentIndex = 0;
            return;
          }

          let index = this.filteredSteps.findIndex((item: any) => item.id === stepId);

          if (index === -1) {
            index = this.filteredSteps.findIndex((item: any) => item.id === this.step_details?.id);
          }

          if (index === -1) {
            index = 0;
          }

          this.currentIndex = index;
          this.currentStepId = this.filteredSteps[index]?.id;
          this.step_details = this.filteredSteps[index];

          this.adjustWindow();
          this.emitAndSyncStep(this.step_details, false);
        }),
        map(() => void 0),
        catchError((error) => {
          console.error('Error loading step permissions:', error);
          return of(void 0);
        })
      );
  }
  
  private emitAndSyncStep(step: any, updateRoute: boolean = true): void {
    if (!step) return;
  
    this.step_details = step;
    this.currentStepId = step.id;
    this.currentStepChange.emit(step);
    this.getWorkflowLogs();
  
    if (updateRoute) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { step: step.id },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }
  
  private adjustWindow(): void {
    if (this.currentIndex < this.startIndex) {
      this.startIndex = this.currentIndex;
    } else if (this.currentIndex >= this.startIndex + this.windowSize) {
      this.startIndex = Math.max(this.currentIndex - this.windowSize + 1, 0);
    }
  }
  
  onActiveIndexChange(event: any): void {
    if (!event) return;
  
    const index = this.filteredSteps?.findIndex((s: any) => s.id === event.id) ?? -1;
    if (index === -1) return;
  
    this.currentIndex = index;
    this.adjustWindow();
    this.emitAndSyncStep(event, true);
  }
  
  navigate(direction: number, pTrigar?: boolean, isCurrent?: boolean): void {
    if (!this.filteredSteps?.length) return;
  
    let targetIndex = this.currentIndex + direction;
  
    if (isCurrent === true) {
      this.getpermDetails(this.step_details?.id);
      return;
    }
  
    if (targetIndex < 0 || targetIndex >= this.filteredSteps.length) return;
  
    if (pTrigar === true) {
      const targetId = this.filteredSteps[targetIndex]?.id;
      if (targetId) {
        this.getpermDetails(targetId);
        return;
      }
    }
  
    this.currentIndex = targetIndex;
    this.adjustWindow();
    this.emitAndSyncStep(this.filteredSteps[targetIndex], true);
  }
  
  get visibleSteps() {
    return this.filteredSteps?.slice(this.startIndex, this.startIndex + this.windowSize) || [];
  }
  
  getStepNumber(step: any): number {
    const index = this.filteredSteps?.findIndex((s: any) => s.id === step?.id) ?? -1;
    return index >= 0 ? index + 1 : 0;
  }
  
  isCurrent(step: any): boolean {
    return this.step_details?.id === step?.id;
  }
  
  isStepCompleted(step: any): boolean {
    if (!step || !this.filteredSteps?.length || !this.step_details?.id) return false;
  
    const currentIndex = this.filteredSteps.findIndex((s: any) => s.id === this.step_details.id);
    const stepIndex = this.filteredSteps.findIndex((s: any) => s.id === step.id);
  
    if (currentIndex === -1 || stepIndex === -1) return false;
  
    return stepIndex < currentIndex && step.step_status === 'approved';
  }
  // ====== Route Config & Command Lists ======

  getCammandList() {
    this.api.getAPI(`/master/commands/`).subscribe((res: any) => {
      this.commandList = res.data;
    });
  }

  getUserListForRouteConfig() {
    const unitId = Number(sessionStorage.getItem('unit_id'));
    this.api.getAPI(`/account/users/?unit_id=${unitId}`).subscribe((res: any) => {
      this.userList = res.data;
    });
  }

  getUnitForRouteConfig() {
    const currentUnitId = sessionStorage.getItem('unit_id');
    this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data.filter((u: any) => u.id != Number(currentUnitId));
    });
  }

  // ====== Dialog & Modal ======

  openDialog() {
    this.messageService.clear('confirm');
    this.displayDialog = true;
    this.getUserListForRouteConfig();
    this.getUnitForRouteConfig();
    this.getCammandList();
    this.resetForm();
  }

  closeModal(): void {
    this.showModal = false;
    this.selectedUnitflow = null;
  }

  // ====== Form / Data Utilities ======

  resetForm() {
    this.shareType = null;
    this.selectedUser = null;
    this.selectedUsers = [];
    this.selectedUnits = [];
    this.permissionType = null;
    this.isFinalApproval = false;
    this.selectedUnit = null;
    this.internalComment = '';
    this.externalComment = '';
    this.selectedCommand = null;
  }

  // ====== Workflow/Timeline Data ======

  getWorkflowLogs() {
    this.api.getAPI(`/file_mange/proposal/${this.step_details?.id}/timeline`).subscribe((res: any) => {
      console.log(res);
      this.timelineDataList = res.timeline;
      this.resetForm()
    });
  }

  // ====== Signature (QR CODE) ======

  addSignature() {
    this.signatureData = this.userList.find((user: any) => user.id == this.currentUser);
    const comment = this.signatureData;
    const qrText = `Electronically Signed by: ${comment.created_by?.first_name} ${comment.created_by?.last_name} | 
      Rank: ${comment.created_by?.rankName || 'N/A'} | 
      Directorate: ${comment.unit?.name || 'N/A'} | 
      Designation: ${comment.created_by?.hrcdf_designation || 'N/A'}`;

    this.generateQRCode(qrText).then(url => {
      this.signatureData.qr_code = url;
    }).catch(err => {
      console.error('QR Code generation failed', err);
    });
  }

  generateQRCode(text: string): Promise<string> {
    return QRCode.toDataURL(text);
  }

  // ====== Share/Editor/Comment Actions ======

  submitShare() {
    if (!this.step_details) return;
    if (this.shareType === 'external' && !this.signatureData) return;

    // Edit
    if (this.permissionType === 'edit') {
      if (this.shareType === 'internal') {
        if (!this.selectedUser) return;
        if (!this.selectedUnitflow?.is_external_user) {
          this.assignEditorUser();
          this.displayDialog = false;
          return;
        }
        this.exUserSetInUser();
        this.displayDialog = false;
        return;
      }
      if (this.shareType === 'external') {
        if (!this.selectedUnit) return;
        this.assignEditorUser();
        this.displayDialog = false;
        return;
      }
    }

    // Comment
    if (this.permissionType === 'comment') {
      if (this.selectedUsers && this.shareType === 'internal' && (!this.selectedUnitflow?.is_external_user ||  (this.editorData.editors[0]?.is_external_user && this.selectedUnitflow.loginname == this.editorData.editors[0]?.loginname)  ) ) {
        this.displayDialog = false;
        this.addCommentTurn();
        return;
      }
      if (this.selectedUsers && this.shareType === 'internal' && this.selectedUnitflow?.is_external_user) {
        this.displayDialog = false;
        this.addCommentUser();
        return;
      }
      if (this.selectedUnits && this.shareType === 'external') {
        this.displayDialog = false;
        this.addCommentTurn();
        return;
      }
      return;
    }

    // View
    if (this.permissionType === 'view') {
      console.warn('View permission flow not implemented yet');
      return;
    }
  }

  assignEditorUser() {
    const payload: any = {
      proposal_step: this.step_details.id,
      is_external: this.shareType === 'external',
      is_final_editor: this.isFinalApproval,
      remarks:this.internalComment
    };
    if (this.shareType === 'external') {
      payload.unit_id = this.selectedUnit?.id;
    } else {
      payload.user = this.selectedUser?.id;
    }

    this.api.postAPI('/file_mange/editor/add/', payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.status || 'Editor assigned successfully.' });
      this.getWorkflowLogs();
    });
  }

  exUserSetInUser() {
    const payload: any = {
      editor_turn: this.selectedUnitflow?.editor_id || this.step_details?.editor_id,
      user: this.selectedUser?.id,
      is_final_editor: this.isFinalApproval,
      remarks:this.internalComment
    };
    this.api.postAPI('/file_mange/editor/add-user/', payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.status || 'External user assigned successfully.' });
      this.getWorkflowLogs();
    });
  }

  addCommentTurn() {
    const payload: any = {
      editor_turn: this.selectedUnitflow?.editor_id || this.step_details?.editor_id,
      is_external: this.shareType === 'external',
      remarks:this.internalComment
    };
    if (payload.is_external) {
      payload.unit_ids = this.selectedUnits;
    } else {
      payload.user_ids = this.selectedUsers;
    }

    this.api.postAPI('/file_mange/comment/turn/add/', payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.status || 'Comment turn added successfully.' });
      this.getWorkflowLogs();
    });
  }

  addCommentUser() {
    const payload: any = {
      comment_turn: this.selectedUnitflow?.comment_turn_id || this.step_details?.comment_turn_id,
      user_ids: this.selectedUsers,
      remarks:this.internalComment
    };
    this.api.postAPI('/file_mange/comment/user/add/', payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.status || 'Comment user added successfully.' });
      this.getWorkflowLogs();
    });
  }

  // ====== Permission & Group Logic ======

  handleUnitClick(unit: any): void {
    this.selectedUnitflow = unit;
    this.editorData = unit;
    this.showModal = true;
  }

  giveTheRouteconfigAccess(currentUnit?: any) {
    if (currentUnit) {
      this.selectedUnitflow = currentUnit;
    }
    // Reset all to true (default)
    this.accessObje = { edit: true, view: true, comment: true };
    if (currentUnit?.editor_id) {
      this.accessObje.edit = true;
      this.accessObje.comment = true;
      this.accessObje.view = true;
    }
    if (currentUnit?.can_comment) {
      this.accessObje.comment = true;
      this.accessObje.view = false;
      this.accessObje.edit = false;
      this.shareType = 'internal';
      this.permissionType = 'comment';
    }
    return;
  }

  processGroups(users: any[]) {
    const externalUsers = users.filter(u => u.is_external_user);
    const groups = externalUsers.reduce((acc, user) => {
      const turnId = user.unit_id;
      if (!acc[turnId]) {
        acc[turnId] = {
          turn_id: turnId,
          expanded: false,
          users: []
        };
      }
      acc[turnId].users.push(user);
      return acc;
    }, {});
    this.groupedCommentTurns = Object.values(groups);
  }

  // ====== UI Helper Methods ======

  getStatusColor(status: string): string {
    switch (status) {
      case 'working':
        return 'bg-blue-500';
      case 'completed':
        return 'bg-green-500';
      case 'blocked':
        return 'bg-red-500';
      default:
        return 'bg-orange-500';
    }
  }

  trackByUnitId(index: number, unit: any): number {
    return unit.id;
  }


//  Skipped Step logic ----------------------------------------
openPop = false;
steps: any[] = [];

open(): void {
  this.openPop = true;
  this.steps = (this.apiResponseSteps || []).map((x: any) => ({
    id: x.id,
    code: x.code,
    name: x.name,
    sequence: x.sequence,
    skipped: !!x.skipped,
    remark: x.remark || '',
    status: !!x.is_approved
  }));
}

valid(): boolean {
  return this.steps.every((s: any) => !s.skipped || !!s.remark?.trim());
}

save(): void {
  const payload = this.steps.map((s: any) => ({
    id: s.id,
    skipped: !!s.skipped,
    remark: s.skipped ? s.remark.trim() : null
  }));

  this.api.postAPI('/transaction/proposal/update-skip/step/', payload).subscribe({
    next: (res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res?.status || 'Step skip settings updated successfully.'
      });

      this.openPop = false;
      this.getpermDetails(this.step_details?.id || this.currentStepId);
    },
    error: () => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update skipped steps.'
      });
    }
  });
}
isSkipDisabled(step: any, index: number): boolean {
  if (step?.status) return true;
  return false;
}
getBlockVisible(commentors: any[], type: string): boolean {
  if(type === 'isExternal') {
    return commentors?.some(data=> data.is_external_user);
  }
  if(type === 'isInternal') {
    return commentors?.some(data=> !data.is_external_user);
  }
  return false;
}


// ====== Skip Test Properties ======

get showShortCloseButton(): boolean {
  const unitId = this.currentUnit; // +sessionStorage.getItem('unit_id')
  const roleId = this.currentUserRoleId; // Number(sessionStorage.getItem('user_role_id'))

  // unit_id == 1 and user_role_id == 6 
  // OR unit_id == 8 and user_role_id in [18, 19, 20, 21]
  return (unitId === 1 && roleId === 6) ||
         (unitId === 8 && [18, 19, 20, 21].includes(roleId));
}

openSkipTestPop: boolean = false;
skipTestRemarks: string = '';
isSkipTestLoading: boolean = false;
uploadedDocumentId: any = null;
@Input() stepDetails: any;

// ====== Skip Test Methods ======

/**
 * Open Skip Test popup
 */


/**
 * Handle document upload success
 */
onDocumentUploadSuccess(event: any): void {
  this.uploadedDocumentId = event?.id || event?.document_id;
  this.messageService.add({
    severity: 'success',
    summary: 'Success',
    detail: 'Document uploaded successfully.'
  });
}



selectedFile: File | null = null;
isFileUploading: boolean = false;
uploadedFileInfo: any = null;



/**
 * Upload file to server
 */
uploadFile(): void {
  if (!this.selectedFile) {
    return;
  }

  this.isFileUploading = true;
  
  const formData = new FormData();
  formData.append('file', this.selectedFile);
  formData.append('proposal_step', this.step_details?.id?.toString() || '');
  formData.append('uploaded_by', this.currentUser?.toString() || '');

  // Replace '/api/upload-document/' with your actual API endpoint
  this.api.postAPI('/api/upload-document/', formData).subscribe({
    next: (res: any) => {
      this.uploadedDocumentId = res?.id || res?.document_id;
      this.uploadedFileInfo = res;
      
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'File uploaded successfully'
      });
    },
    error: (error: any) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.error?.message || 'Failed to upload file'
      });
      this.selectedFile = null;
    },
    complete: () => {
      this.isFileUploading = false;
    }
  });
}
/**
 * Upload file to server - REMOVE THIS METHOD (we'll upload with submit)
 */
// DELETE the uploadFile() method - we don't need separate upload anymore

/**
 * Handle file selection - SIMPLIFIED VERSION
 */
onFileSelected(event: any): void {
  const file = event.target.files[0];
  
  if (!file) {
    return;
  }

  // Validate file size (max 10MB)
  const maxSize = 10 * 1024 * 1024; // 10MB in bytes
  if (file.size > maxSize) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'File size must be less than 10MB'
    });
    return;
  }

  this.selectedFile = file;
  
  this.messageService.add({
    severity: 'success',
    summary: 'Success',
    detail: 'File selected successfully'
  });
}

/**
 * Submit Skip Test - UPDATED TO USE PUT API
 */
submitSkipTest(): void {
  if (!this.skipTestRemarks?.trim()) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please enter remarks before submitting.'
    });
    return;
  }

  if (!this.selectedFile) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please upload a document before submitting.'
    });
    return;
  }

  this.isSkipTestLoading = true;

  // Create FormData for file upload
  const formData = new FormData();
  formData.append('proposal_status', 'short_close');
  formData.append('remark', this.skipTestRemarks.trim());
  formData.append('file', this.selectedFile);

  // Use PUT method with proposal ID in URL
  const url = `/master/proposals/${this.proposalId}/`;

  this.api.putAPI(url, formData).subscribe({
    next: (res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res?.status || res?.message || 'Short close completed successfully.'
      });
      
      this.openSkipTestPop = false;
      this.skipTestRemarks = '';
      this.selectedFile = null;
      this.uploadedFileInfo = null;
      this.uploadedDocumentId = null;
      
      // Refresh workflow logs
      this.getWorkflowLogs();
    },
    error: (error: any) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.error?.message || error?.message || 'Failed to complete short close.'
      });
      this.isSkipTestLoading = false;
    },
    complete: () => {
      this.isSkipTestLoading = false;
    }
  });
}

/**
 * Remove selected file
 */
removeFile(event: Event): void {
  event.stopPropagation();
  event.preventDefault();
  
  this.selectedFile = null;
  this.uploadedDocumentId = null;
  this.uploadedFileInfo = null;
}

/**
 * Format file size for display
 */
formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Open Skip Test popup
 */
openSkipTestPopup(): void {
  this.openSkipTestPop = true;
  this.skipTestRemarks = '';
  this.uploadedDocumentId = null;
  this.selectedFile = null;
  this.uploadedFileInfo = null;
  this.isFileUploading = false;
}

// ====== Legacy Data Properties ======
openLegacyDataPop: boolean = false;
legacySelectedFile: File | null = null;
isLegacyFileUploading: boolean = false;
legacyDocuments: any[] = []; // Store all uploaded documents
legacyName: string = ''; // Document name
legacyDescription: string = ''; // Document description

// ====== Legacy Data Methods ======

/**
 * Open Legacy Data popup and fetch existing documents
 */
openSkipTestPopup1(): void {
  this.openLegacyDataPop = true;
  this.resetLegacyForm();
  this.fetchLegacyDocuments(); // Load existing documents
}

/**
 * Reset legacy form
 */
resetLegacyForm(): void {
  this.legacySelectedFile = null;
  this.legacyName = '';
  this.legacyDescription = '';
}

/**
 * Fetch existing legacy documents
 */
fetchLegacyDocuments(): void {
  const url = `/transaction/legacy/data/?proposal=${this.proposalId}`;
  
  this.api.getAPI(url).subscribe({
    next: (res: any) => {
      this.legacyDocuments = res.data || res.results || res || [];
      console.log('Legacy documents loaded:', this.legacyDocuments);
    },
    error: (error: any) => {
      console.error('Error fetching legacy documents:', error);
      this.legacyDocuments = [];
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load legacy documents'
      });
    }
  });
}

/**
 * Handle legacy file selection
 */
onLegacyFileSelected(event: any): void {
  const file = event.target.files[0];
  
  if (!file) {
    return;
  }

  // Validate file size (max 10MB)
  const maxSize = 10 * 1024 * 1024;
  if (file.size > maxSize) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'File size must be less than 10MB'
    });
    event.target.value = ''; // Reset input
    return;
  }

  this.legacySelectedFile = file;
  
  // Auto-fill name from filename if empty
  if (!this.legacyName.trim()) {
    this.legacyName = file.name.split('.')[0]; // Remove extension
  }
}

/**
 * Remove selected legacy file
 */
removeLegacyFile(event: Event): void {
  event.stopPropagation();
  event.preventDefault();
  this.legacySelectedFile = null;
}

/**
 * Upload legacy document
 */
uploadLegacyDocument(): void {
  // Validation
  if (!this.legacySelectedFile) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please select a file to upload'
    });
    return;
  }

  if (!this.legacyName?.trim()) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please enter document name'
    });
    return;
  }

  if (!this.legacyDescription?.trim()) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please enter description'
    });
    return;
  }

  this.isLegacyFileUploading = true;

  // Prepare FormData
  const formData = new FormData();
  formData.append('proposal', this.proposalId?.toString() || '');
  formData.append('name', this.legacyName.trim());
  formData.append('description', this.legacyDescription.trim());
  formData.append('file', this.legacySelectedFile);

  const url = `/transaction/legacy/data/`;

  this.api.postAPI(url, formData).subscribe({
    next: (res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Document uploaded successfully'
      });
      
      // Reset form
      this.resetLegacyForm();
      
      // Refresh document list
      this.fetchLegacyDocuments();
    },
    error: (error: any) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.error?.message || error?.error?.detail || 'Failed to upload document'
      });
    },
    complete: () => {
      this.isLegacyFileUploading = false;
    }
  });
}

/**
 * Delete legacy document
 */
deleteLegacyDocument(documentId: number): void {
  if (!confirm('Are you sure you want to delete this document?')) {
    return;
  }

  const url = `/transaction/legacy/data/${documentId}/`;
  
  this.api.deleteAPI(url).subscribe({
    next: (res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Document deleted successfully'
      });
      this.fetchLegacyDocuments();
    },
    error: (error: any) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.error?.message || 'Failed to delete document'
      });
    }
  });
}

/**
 * Download legacy document
 */
downloadLegacyDocument(document: any): void {
  if (document.file) {
    window.open(document.file, '_blank');
  } else if (document.file_url) {
    window.open(document.file_url, '_blank');
  } else {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'File URL not available'
    });
  }
}

/**
 * Format file size
 */
// formatFileSize(bytes: number): string {
//   if (!bytes || bytes === 0) return '0 Bytes';
//   const k = 1024;
//   const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//   const i = Math.floor(Math.log(bytes) / Math.log(k));
//   return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
// }

/**
 * Get file extension from filename
 */
getFileExtension(filename: string): string {
  return filename?.split('.').pop()?.toUpperCase() || 'FILE';
}
}
